
import axios from "axios";
import { OutputBaseProps } from "utils/types/API";
import { DataItemProps } from ".";
import { AppMessage } from "components";

interface DataSaveProps extends Omit<DataItemProps, "id"> {
    id?: number;
}
interface ApiDataSaveInputProps extends Omit<DataItemProps, "id"> {
    uid?: string;
    item: DataSaveProps;
    workflowId?: number;
    stepId?: number;

}

type ApiDataSaveOutputProps = OutputBaseProps<{ item: DataItemProps; }, ApiDataSaveInputProps>

export const apiDataSave = async (data: ApiDataSaveInputProps, formCode: string) => {
    const res = (await axios.post<ApiDataSaveOutputProps>(`/api/data/${formCode}/save`, data))
        .data;
    if (res.code === 0 && res.data) {
        AppMessage.success({
            title: "Thông báo",
            message: res.message
        })
    }
    return res;
};